import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const UnauthorizedPage = () => {
  const { userInfo, logout, isWhitelisted, isAdmin } = useAuth();

  if (isWhitelisted || isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="container">
      <div className="row justify-content-center align-items-center vh-100">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow">
            <div className="card-body p-5 text-center">
              <div className="mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="80"
                  height="80"
                  fill="currentColor"
                  className="text-warning"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
              </div>

              <h2 className="mb-3">Acesso Pendente</h2>

              <p className="text-muted mb-4">
                Sua conta foi criada com sucesso, mas ainda nao foi autorizada para
                acessar o sistema.
              </p>

              {userInfo && (
                <div className="alert alert-info mb-4">
                  <strong>Email:</strong> {userInfo.email}
                </div>
              )}

              <p className="mb-4">
                Um administrador precisa aprovar seu acesso. Voce sera notificado
                quando sua conta for ativada.
              </p>

              <div className="d-grid gap-2">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => window.location.reload()}
                >
                  Verificar Novamente
                </button>
                <button className="btn btn-secondary" onClick={logout}>
                  Sair
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
